import React, { useState, useEffect, useContext } from 'react'
import { FormattedMessage } from 'react-intl'

import { FiltersContext } from 'client/components/FiltersContainer/context'

import Checkbox from 'src/comps/Checkbox'
import IconStar from 'client/icons/Star'

import { colors } from 'client/styles'
import { FilterCategoryBase, Title, List } from './styles'
import messages from './messages'

const availableCategories = ['5', '4', '3', '2', '1']
const hideCategories = ['1']

const FilterCategory = () => {
  const { filters, setFilters } = useContext(FiltersContext)
  const [selected, setSelected] = useState([])

  useEffect(() => {
    setSelected(filters.stars || [])
  }, [filters.stars])

  function handleClick(category) {
    const index = selected.indexOf(category)
    const isActive = index > -1

    const selectedCategories = isActive
      ? selected.filter((c, i) => i !== index).sort()
      : [...selected, category].sort()

    if (selectedCategories.filter(c => !hideCategories.includes(c)).length > 0) {
      setFilters({ ...filters, stars: selectedCategories })
      return
    }

    setFilters({
      ...filters,
      stars: [],
    })
  }

  function buildStars(category) {
    return (
      <>
        {Array(Number(category))
          .fill()
          .map((_, i) => (
            /* eslint-disable-next-line react/no-array-index-key */
            <IconStar key={i} size={14} fill={colors.grey2} className="star-icon" />
          ))}
      </>
    )
  }

  return (
    <FilterCategoryBase data-testid="filter-category">
      <Title>
        <FormattedMessage {...messages.category} />
      </Title>

      <List>
        {availableCategories
          .filter(c => !hideCategories.includes(c))
          .map(category => {
            const isSelected = selected.includes(category)
            return (
              <li key={`star-${category}`}>
                <Checkbox
                  label={buildStars(category)}
                  name={`star-${category}`}
                  onChange={() => handleClick(category)}
                  selected={isSelected}
                />
              </li>
            )
          })}
      </List>
    </FilterCategoryBase>
  )
}

export default FilterCategory
